<template>
  <div>
    <el-form :model="selectForm" label-width="80px" ref="selectForm">
      <el-row>
        <el-col :span="8">
          <el-form-item label="始发站" prop="DepartureStation">
            <el-input v-model="selectForm.DepartureStation" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="终点站" prop="Terminal">
            <el-input v-model="selectForm.Terminal" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <baidu-map>
      <bm-view class="map" center="琼中">
      </bm-view>
      <bm-transit :start="selectForm.DepartureStation" :end="selectForm.Terminal" :auto-viewport="true"
        location="琼中"></bm-transit>
    </baidu-map>
  </div>
</template>

<script>
import { BaiduMap, BmControl, BmView, BmAutoComplete, BmLocalSearch, BmMarker, BmNavigation } from 'vue-baidu-map'
export default {
  components: {
    BaiduMap,
    BmControl,
    BmView,
    BmAutoComplete,
    BmLocalSearch,
    BmMarker,
    BmNavigation,
  },
  data: function () {
    return {
      selectForm: {
        DepartureStation: "",
        Terminal: ""
      }
    }
  }
}
</script>

<style scoped>
.map {
  width: 100%;
  height: 600px;
}
</style>
